import { Box, Divider, Typography } from "@mui/material";

import { useBszPlannerContext } from "../../context/bszPlannerContext";
import BszSectionCard from "../../../1_BSZFinderApp/components/sectionCards/BszSectionCard";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import PlannerProjectsHistoryDialog from "./PlannerProjectsHistoryDialog";

export default function PlannerMyProjectsSection() {
  const theme = useTheme();
  const { currentUser } = useAppContext();
  const { projects = [], selectedClass = null } = useBszPlannerContext();

  const [showHistory, setShowHistory] = useState(false);

  const visibleProjects = selectedClass
    ? projects.filter((project) =>
        (project.classes || []).some((cls) => cls.id === selectedClass.id),
      )
    : projects.filter((project) => project.teacherId === currentUser.id);

  const activeProjects = [...visibleProjects]
    .filter((project) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const due = new Date(project.dueDate);
      due.setHours(0, 0, 0, 0);

      return due >= today;
    })
    .sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));

  return (
    <BszSectionCard
      title={
        selectedClass
          ? `Laufende Projekte · ${selectedClass.name}`
          : "Meine Projekte"
      }
      defaultExpanded={false}
      showAll={true}
      setShowHistory={setShowHistory}
      visibleProjects={visibleProjects}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        {selectedClass && (
          <Typography variant="body2" color={theme.palette.text.secondary}>
            Total {activeProjects.length} Projekte
          </Typography>
        )}

        <Box
          sx={{
            maxHeight: 250,
            overflowY: "auto",
            pr: 1,
          }}
        >
          {activeProjects.map((project) => (
            <Box key={project.id}>
              <Typography fontWeight={600}>{project.title}</Typography>

              <Typography variant="body2" color="text.secondary">
                {selectedClass
                  ? project.subjectName
                  : `${project.classes[0]?.name} - ${project.subjectName}`}
              </Typography>

              <Typography variant="body2" color="text.secondary">
                Fällig am{" "}
                {new Date(project.dueDate).toLocaleDateString("de-CH")}
              </Typography>

              <Typography variant="body2" color="text.secondary">
                {project.estimatedMinutes} Minuten
              </Typography>

              <Divider sx={{ mt: 1 }} />
            </Box>
          ))}
        </Box>

        <PlannerProjectsHistoryDialog
          open={showHistory}
          onClose={() => setShowHistory(false)}
          projects={visibleProjects}
          selectedClass={selectedClass}
        />
      </Box>
    </BszSectionCard>
  );
}
